function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12.0012 19.9988H2.00117C1.46524 20.0175 0.945643 19.8127 0.566457 19.4336C0.187272 19.0545 -0.0174554 18.5349 0.00116824 17.9991V8.00023C-0.0174554 7.46437 0.187272 6.94483 0.566457 6.56569C0.945643 6.18655 1.46524 5.98185 2.00117 6.00047H6.00117V2.00093C5.98255 1.46507 6.18728 0.945532 6.56646 0.566391C6.94565 0.18725 7.46525 -0.0174533 8.00117 0.0011681H18.0012C18.5371 -0.0174533 19.0567 0.18725 19.4359 0.566391C19.8151 0.945532 20.0198 1.46507 20.0012 2.00093V11.9998C20.0195 12.5355 19.8147 13.0549 19.4356 13.434C19.0564 13.8131 18.537 14.0179 18.0012 13.9995H14.0012V17.9991C14.0195 18.5348 13.8147 19.0542 13.4356 19.4333C13.0564 19.8124 12.537 20.0172 12.0012 19.9988ZM2.00117 8.00023V17.9991H12.0012V13.9995H8.00117C7.46533 14.0179 6.94591 13.8131 6.56679 13.434C6.18767 13.0549 5.98285 12.5355 6.00117 11.9998V8.00023H2.00117ZM8.00117 2.00093V11.9998H18.0012V2.00093H8.00117Z",
  fill: "white"
});

function SvgCopy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.0c2cba9d.svg";
export { ForwardRef as ReactComponent };